import React, { useState, useEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";
import PreAceleradoraCard from "../../molecules/pre-aceleradora-card/preAceleradoraCard";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
// Components
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";

//Styles
import "./FormPreAceleradora.scss";

const FormPreAceleradora = (props: any) =>{
    const data = useStaticQuery(graphql`
        query contentfulFormPreAceleradora {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "3fOEHmm7sHItDjQw94qaaF" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                          descripcionFija {
                           raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            obligatorio
                            seccion
                            tabOrder
                            ayuda
                            placeholder
                        }
                        tituloBoton
                    }
                    imagenesEmpleo {
                        file {
                            url
                            details {
                                image {
                                    height
                                    width
                                }
                            }
                        }
                    }
                    imagenFormulario {
                        file {
                            details {
                                image {
                                    width
                                    height
                                }
                            }
                            url
                        }
                    }
                    tituloUbicacion
                }
            }
            modalSentPre: allContentfulContactenos(
                filter: { contentful_id: { eq: "6wmqLaSh0ABsolBCsgfIO3" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalDeshabilitar: allContentfulContactenos(
                filter: { contentful_id: { eq: "13weMo2Nf1LgerLFav6kLv" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                    formularioCeidActivo
                    fechaInicioConvocatoria
                    fechaFinConvocatoria
                }
            }
            modalError: allContentfulPlantillaContenido(
                  filter: {  contentful_id: { eq: "1hhl56VQ5PiOz0FMYez2Hs"}   }
            ) {
                  nodes {
                     imagenPrincipal {
                        file { 
                           url 
                        }
                        description
                     }
                     descripcion  { 
                        raw
                     }
                     descripcionFija {
                        raw
                     }
                     tituloBanner
                     tituloDescripcion
                     tituloBoton
                     redireccionBoton
                  }
               }
        }
    `);
    
    const contentfulData = data.form.nodes[0];
    const contentfulModalSentPre = data.modalSentPre.nodes[0];
    const contentfulModalError = data.modalError.nodes[0];
    const contentfulModalDeshabilitar = data.modalDeshabilitar.nodes[0];

    const { isBrowser, window } = useBrowserMode();
    const [pathname, setPathname] = useState("");

    useEffect(() => {
        const getPathname = () => {
            if(isBrowser) {
                if (window.location.pathname.includes("personas")) {
                    setPathname("Personas")
                }
            }
        }

        getPathname();
    }, [])
    
    return (
        <>
            <div className="m-form-pre-aceleradora">
                <div className="m-breadcrumb">
                    <Breadcrumb content={ `Inicio / ${pathname} / ${contentfulData.tituloPrincipal}` } />
                </div>
                <>
                    <PreAceleradoraCard 
                        tituloPrincipal={contentfulData.tituloPrincipal}
                        tituloFormulario={contentfulData.tituloFormulario}
                        tituloUbicacion={contentfulData.tituloUbicacion}
                        titulosFormulario={contentfulData.titulosFormulario}
                        metaTitulo={contentfulData.metaTitulo}
                        modalSuccess={contentfulModalSentPre}
                        modalError={contentfulModalError}
                        modalDeshabilitar={contentfulModalDeshabilitar}
                    />
                </>
            </div>
        </>
    );
};

export default FormPreAceleradora;
